import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Entrega',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Servicio a la habitación',
      [RoomServiceLocationType.TableService]: 'Servicio en mesa',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Nombre del timbre (opcional)',
    },
    company_name: {
      placeholder: 'Nombre de empresa (opcional)',
    },
    customer_note: {
      placeholder: 'Instrucciones de entrega (opcional)',
    },
    order_instructions: {
      placeholder: 'Escribe las instrucciones del pedido...',
    },
  },
};
